<template>
    <div class="mb-50 my-lg-50 display-none display-md-block">
        <ul class="list-unstyled hstack hstack--align-center">
            <li @click="filter('')">
                <button class="btn btn--skyblue btn--outline">Alles</button>
            </li>
            <li v-for="categorie in categorieen" :key="categorie.id" @click="filter(categorie.id)">
                <button class="btn btn--skyblue btn--outline">
                    <span v-html="categorie.icon"></span>
                    {{ categorie.naam }}
                </button>
            </li>
        </ul>
    </div>

    <div class="mb-32 display-md-none">
        <select class="form-select" v-model="selectedCategorie" @change="filter(selectedCategorie)">
            <option value="">Alles</option>
            <option v-for="categorie in categorieen" :key="categorie.id" :value="categorie.id">
                {{ categorie.naam }}
            </option>
        </select>
    </div>

    <div class="layout-grid grid-cols-sm-2 grid-cols-lg-3 grid-cols-xl-4 g-16 g-sm-24 activiteiten activiteiten--home">
        <article
            v-for="item in items"
            :key="itemKey(item)"
            class="card activiteiten__item"
        >
            <div v-if="hasImage(item)" class="card__cover aspect-ratio" style="--_ratio: 312 / 232">
                <img
                    :src="baseUrl + item.foto"
                    alt=""
                    width="500"
                    height="300"
                    loading="lazy"
                    @error="markImageFailed(item)"
                />
                <ul v-if="item.categorie && item.categorie.length" class="list-unstyled activiteiten__taglist hstack">
                    <li
                        v-for="categorie in item.categorie"
                        :key="categorie.id"
                        class="activiteiten__tag"
                        v-html="categorie.svg"
                    ></li>
                </ul>
            </div>

            <div class="card__body">
                <h3 class="card__title h6" v-html="item.naam"></h3>
                <div class="card__content">
                    <p class="truncate" style="--_max-lines: 3;" v-html="item.omschrijving"></p>
                </div>
            </div>

            <div class="card__footer">
                <a :href="item.url" class="btn fs-300 w-100 justify-content-between clr-orange p-0 stretched-link">
                    {{ buttonLabel(item.type) }}
                    <span class="icon-basic icon-arrow-right fs-600"></span>
                </a>
            </div>
        </article>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: [],
            categorieen: [],
            baseUrl: "/slir/w1920",
            selectedCategorie: "",
            limit: null,
            failedImages: {},
        };
    },
    methods: {
        itemKey(item) {
            return item.type + "-" + item.id;
        },
        hasImage(item) {
            return !!item.foto && !this.failedImages[this.itemKey(item)];
        },
        markImageFailed(item) {
            this.failedImages = {
                ...this.failedImages,
                [this.itemKey(item)]: true,
            };
        },
        buttonLabel(type) {
            if (type === "route") return "Bekijk route";
            if (type === "agenda") return "Bekijk agenda-item";
            return "Bekijk activiteit";
        },
        fetchItems(filter = "") {
            const params = new URLSearchParams();

            if (filter) {
                params.append("filter", filter);
            }

            if (this.limit) {
                params.append("limit", this.limit);
            }

            let url = "/api/activiteiten";

            if (params.toString()) {
                url += "?" + params.toString();
            }

            fetch(url)
                .then((res) => res.json())
                .then((data) => {
                    this.items = data.items ?? [];
                    this.failedImages = {};
                });
        },
        filter(id) {
            this.selectedCategorie = id;
            this.fetchItems(id);
        },
    },
    mounted() {
        const el = document.getElementById("activiteiten-app");
        this.limit = el?.dataset?.limit ?? null;

        this.fetchItems();

        fetch("/api/categorieen")
            .then((res) => res.json())
            .then((data) => {
                this.categorieen = data;
            });
    },
};
</script>
